import BaseUseCase from "../../../base_use_case.js";

class ShowProjectUseCase extends BaseUseCase {

  execute(identifier) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/admin/projects/projects/${identifier}`,
      params: {
        findBySlug: true
      },
    });
  }
}

const instance = new ShowProjectUseCase();
export default instance;